export interface ILinkingServiceStrategy {
  getSessionOrigin(): string | null;
  getRefreshToken(): string | null;
}

/* 
This service is used:
  - in app to handle deep linking (TODO)
  - in the webapp to parse url parameters, store session origin and get refreshToken from url in debug mode 
*/
export class LinkingService {
  public static getInstance() {
    if (!LinkingService._instance) {
      LinkingService._instance = new LinkingService();
    }

    return LinkingService._instance;
  }

  private static _instance: LinkingService;
  private _strategy: ILinkingServiceStrategy;
  private constructor() {}

  public set strategy(value: ILinkingServiceStrategy) {
    this._strategy = value;
  }
  public get strategy(): ILinkingServiceStrategy {
    if (!this._strategy) {
      throw new Error(
        'affiny-core/services/linking.ts you cannot call .strategy before configure it. Search LinkingService.strategy setter method'
      );
    }

    return this._strategy;
  }

  public getSessionOrigin() {
    return this.strategy.getSessionOrigin();
  }

  public getRefreshToken() {
    return this.strategy.getRefreshToken();
  }
}

export const linkingService = LinkingService.getInstance();
